import type { OktaAuth } from "@okta/okta-auth-js";
import type { InjectionKey, Plugin } from "vue";
import { oktaAuth } from "@/main";
export const oktaPlugin: InjectionKey<OktaAuth> = Symbol("auth");
export let oktaAuthInstance: OktaAuth;

export const registerOkta: Plugin = {
  install(app) {
    oktaAuthInstance = oktaAuth;
    app.provide(oktaPlugin, app._context.config.globalProperties.$auth);
  }
};
